import React, { useState } from "react";
import TermsAndConditionsModal from "../../components/TermsAndConditionsModal";

export const TermsAndConditionsPage = ({ refetch }) => {
  const [open, setOpen] = useState(true);

  return (
    <div>
      {" "}
      <TermsAndConditionsModal
        open={open}
        setOpen={setOpen}
        refetch={refetch}
      />
    </div>
  );
};
